import { Clickable, Col, H2, P, Row, Section } from '@ahmdigital/ui';
import { FC } from 'react';
import { map } from 'lodash/fp';
import styled from 'styled-components';

import { focusVisible } from '../branch';
import otherInsuranceContactLinks from './data';

const ContactRow = styled(Row)`
  justify-content: center;
`;

const ContactCol = styled(Col)`
  text-align: center;
  max-width: fit-content;
`;

const Heading = styled(H2)`
  margin-bottom: 2.5rem;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    margin-bottom: 4.5rem;
  }

  ${focusVisible}
`;

const OtherInsuranceContacts: FC = () => (
  <Section variant={['regular', 'marginTopSpacer6', 'marginBottomSpacer6']}>
    <ContactRow>
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call. */}
      <Heading id="Get in touch" tabIndex="0">
        Get in touch
      </Heading>
    </ContactRow>
    {map(
      ({ title, link, description, subtitle }) => (
        <ContactRow variant="marginBottomSpacer9" key={title}>
          <ContactCol>
            <P variant={['bold', 'marginBottomSpacer12']}>{title}</P>
            {subtitle}
            <Clickable variant={description ? 'marginBottomSpacer12' : ''} to={link.url ?? undefined}>
              {link.name}
            </Clickable>
            {description}
          </ContactCol>
        </ContactRow>
      ),
      otherInsuranceContactLinks(),
    )}
    <ContactRow variant="marginTopSpacer7">
      <ContactCol>
        <P variant={['bold', 'marginBottomSpacer12']}>Feedback and complaints</P>
        <Clickable to="https://help.ahm.com.au/hc/en-us/articles/115005292887">Find out more</Clickable>
      </ContactCol>
    </ContactRow>
  </Section>
);

export default OtherInsuranceContacts;
